<template>
    <basic-layout>
        <div class="rra-upper-hero" v-if="title">
            <h1 class="text-xl font-bold flex-grow">{{ title }}</h1>
            <div class="flex justify-end gap-3 mt-4">
                <slot name="actions">
                    <Button
                        class="h-10"
                        icon="pi pi-save"
                        :label="$t('common.save_and_close')"
                        @click="$emit('onSaveBack')"
                    />
                    <Button
                        class="h-10"
                        icon="pi pi-save"
                        severity="secondary"
                        :label="$t('common.save')"
                        @click="$emit('onSave')"
                    />
                    <Button
                        class="h-10"
                        icon="pi pi-times"
                        severity="secondary"
                        :label="$t('common.cancel')"
                        @click="back"
                    />
                </slot>
            </div>
        </div>

        <div
            :class="[
        'rounded-xl min-h-screen',
        borderless ? '' : 'border dark:border-neutral-700 bg-white dark:bg-neutral-900'
      ]"
        >
            <slot></slot>
        </div>
    </basic-layout>
</template>

<script setup>
import BasicLayout from './BasicLayout.vue';
import { defineProps } from 'vue';
import Button from 'primevue/button';

defineProps({
    title: String,
    borderless: Boolean,
});

const back = () => {
    window.history.back();
};
</script>

<style scoped lang="scss">
.rra-upper-hero {
    display: flex;
    align-items: center;
    gap: 12px;
    background-position: center;
    background-size: cover;
    margin-bottom: 24px;
}
</style>
